import { toast } from "react-toastify";
import { observable, runInAction } from "mobx";
import { api } from "../../api";

export class _SpedStore {
  obs = observable({
    tasks_sped: [] as any[],
    length_tasks_sped: 0 as number,
    programar_sped: false as boolean,
    open_detalhes_sped: false as boolean,
    loading: false as boolean,
    
    selectedTab: "sped" as string,

  })

  async handleTasksPaged(paged: number) {
    let data = {
      page: paged,
      limit: 15
    }
    try {
      let resp = await api.post("/api/sped/task/index", data);

      runInAction(() => {
        this.obs.tasks_sped = [];
        this.obs.length_tasks_sped = 0

        if (resp.data.itens.length > 0) {
          this.obs.tasks_sped = resp.data.itens;
          this.obs.length_tasks_sped = resp.data.count
        }
      });
    } catch (ex) { }

  }

  async create_contestacao_task(params: any) {
    try {
      let resp = await api.post("/api/sped/task/create", params);

      if (resp.data.ok) {
        toast.success('Sped Cadastrado', {});
        this.handleTasksPaged(1)
        this.obs.programar_sped = false;
      } else {
        toast.error(resp.data.erro, {});
      }
    } catch (ex) { }

  }

  async handleDownloadArquivoSped(id: string, cnpj: string) {
    SpedStore.obs.loading = true
    try {
      let resp = await api.get(`/api/sped/task/download/${id}`);

      if (!resp.data.ok) {
        SpedStore.obs.loading = false
        toast.error('erro ao baixar o arquivo, tente novamente mais tarde ou contate o suporte.', {});
        return
      }

      const linkSource = `data:application/txt;base64,${resp.data.file}`;
      const downloadLink = document.createElement("a");
      const fileName = cnpj + "- Sped.txt";

      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();

      SpedStore.obs.loading = false
    } catch (ex) { }

  }

}

export const SpedStore = new _SpedStore();
